import React, { useMemo } from 'react'
import { Chip, Tooltip, makeStyles } from '@material-ui/core'
import { Warning } from '@material-ui/icons'
import ToolTipItemPet from '../Pets/ToolTipItemPet'
import { getChipStyles } from '../../services/helpers'

const useStyles = makeStyles((theme) => ({
	root: {
		'& .MuiChip-label': {
			margin: 0
		}
	},
	warning: { fontSize: '15px', fill: 'currentcolor' }
}))

const PetAlert = ({ issues = [] }) => {
	const classes = useStyles()
	const toolTip = useMemo(() => {
		return (
			<div style={{ display: 'flex', flexDirection: 'column' }}>
				{issues.map((i, index) => (
					<ToolTipItemPet key={index} message={i.message} color={i.color || null} />
				))}
			</div>
		)
	}, [issues])

	return (
		<div className={classes.root}>
			{issues && issues.length ? (
				<Tooltip title={toolTip}>
					<Chip
						label={<Warning className={classes.warning} />}
						style={
							issues.some((i) => i.type == 'danger')
								? {
										...getChipStyles('rejected'),
										...{ paddingTop: '6px', margin: 0 }
								  }
								: {
										...getChipStyles('warning'),
										...{ paddingTop: '6px', margin: 0 }
								  }
						}
					/>
				</Tooltip>
			) : null}
		</div>
	)
}

export default PetAlert
